import React from 'react';
import { Link } from 'react-router-dom';

export default function HomeNav({ setMobileToggle }) {
  return (
    <ul className="cs_nav_list fw-medium text-uppercase">
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Accueil
        </Link>
      </li>
      <li>
        <Link to="/about" onClick={() => setMobileToggle(false)}>
          A Propos
        </Link>
      </li>
      <li>
        <Link to="/service" onClick={() => setMobileToggle(false)}>
          Services
        </Link>
      </li>
      <li>
        <Link to="/contact" onClick={() => setMobileToggle(false)}>
          Contact
        </Link>
      </li>
    </ul>
  );
}
